module.exports = __webpack_public_path__ + "static/img/Asset 10.cd91f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Asset 10.png
// module id = 751
// module chunks = 0